export const DONE_STATUS = 'done';
export const DONE_WITH_ERRORS_STATUS = 'done_with_errors';
export const PENDING_STATUS = 'pending';

export const BULK_ACTION_STATUS_LABELS = {
  [DONE_STATUS]: 'Done',
  [DONE_WITH_ERRORS_STATUS]: 'Done w/Error',
  [PENDING_STATUS]: 'Pending',
}

export const bulkActionsReportOptions = [
    {
      text: 'Recent Bulk Actions',
      isArchivedOption: false,
    },
    {
      text: 'Archived Bulk Actions',
      isArchivedOption: true,
    },
];

export const headers = [
  {
    text: 'Bulk Action',
    value: 'description',
    width: '30%',
    class: 'bulk-actions-report-table-header',
    sortable: false,
  },
  {
    text: 'Contacts',
    value: 'contacts_total',
    width: '10%',
    class: 'bulk-actions-report-table-header',
    sortable: false,
  },
  {
    text: 'Status',
    value: 'status',
    width: '15%',
    align: 'center',
    class: 'bulk-actions-report-table-header',
    sortable: false,
  },
  {
    text: ' ',
    value: 'percentage',
    width: '15%',
    class: 'bulk-actions-report-table-header',
    sortable: false,
  },
  {
    text: 'Date',
    value: 'created_at',
    width: '15%',
    class: 'bulk-actions-report-table-header',
    sortable: false,
  },
  {
    text: ' ',
    value: 'actions',
    width: '15%',
    class: 'bulk-actions-report-table-header',
    sortable: false,
  },
];

export const successfulHeaders = [
  {
    text: 'Name',
    value: 'name',
    sortable: false,
  },
  {
    text: 'Email',
    value: 'email',
    sortable: false,
  },
  {
    text: 'Created date',
    value: 'date_created',
    sortable: false,
  },
];

export const failedHeaders = [
  {
    text: 'Name',
    value: 'name',
    sortable: false,
  },
  {
    text: 'Email',
    value: 'email',
    sortable: false,
  },
  {
    text: 'Created date',
    value: 'date_created',
    sortable: false,
  },
  {
    text: 'Error',
    value: 'error',
    sortable: false,
  },
];
